import api from "../api/client";

const pickupOrderApi = {
  create(payload) {
    return api.post("/v1/oc", payload);
  },
};

export default pickupOrderApi;
